import React, { Component } from 'react'
import { compose } from 'recompose'
import withSelectFetch from '../withSelectFetch'
import withSpinning from '../../HOC/withSpinning'
import CustomSelect from '../CustomSelect'
import withSort from '../../HOC/withSort'
import withSubDropdown from '../../HOC/withSubDropdown'

class RecurringFrequency extends Component {
  render() {
    return <CustomSelect placeholder={'Frequency'} {...this.props} />
  }
}

export default compose(
  withSelectFetch({ dropdown: 'lines', name: 'recurring' }),
  withSpinning,
  withSubDropdown({ name: 'frequency' }),
  withSort
)(RecurringFrequency)
